import { Component, OnInit } from '@angular/core';
import {ParamMap} from '@angular/router';
import {forkJoin, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {Utils} from 'src/app/classes/Utils';
import {Pharos_Credentials} from 'src/app/models/RestModels';
import {SearchObject} from 'src/app/services/Rest';
import {BaseComponent} from '../base/base.component';

@Component({
	selector: 'app-list-pharos-credentials',
	templateUrl: './list-pharos-credentials.component.html',
	styleUrls: ['./list-pharos-credentials.component.css']
})
export class ListPharosCredentialsComponent extends BaseComponent implements OnInit
{
	pharos_credentials_search: SearchObject<Pharos_Credentials> = this.getEmptySearch();
	pharos_credentials_list: Pharos_Credentials[] = [];

	ngOnInit(): void
	{
		this.sink = this.route.paramMap.pipe
		(
			mergeMap((param_map:ParamMap)=>
			{
				this.is_loading = true;
				let fields = ['name', 'user', 'merchant_code', 'terminal_code'];
				this.pharos_credentials_search = this.getSearch(param_map, fields)

				return this.rest.pharos_credentials.search(this.pharos_credentials_search);
			})
		)
		.subscribe
		({
			error:(error)=>this.showError( error ),
			next:(response)=>
			{
				this.is_loading = false;
				this.pharos_credentials_list = response.data;
			}
		})
	}
}
